var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71h0V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.48,5.48,0,0,0,5.46-5.46V60.66A5.48,5.48,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.73,5.73,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.7,5.7,0,0,1,453.31,337.8ZM260.21,55.2a5.48,5.48,0,0,0-5.46,5.46V332.09a5.48,5.48,0,0,0,5.46,5.46h193.1a5.48,5.48,0,0,0,5.46-5.46V60.66a5.48,5.48,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 285.56,
    width: 16.42,
    height: 91.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 377.24,
    width: 112.76,
    height: 4.98,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.36,
    y: 285.56,
    width: 97.66,
    height: 91.68,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.81,
    y: 295.24,
    width: 84.75,
    height: 32.32,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.81,
    y: 335.25,
    width: 84.75,
    height: 32.32,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.69,
    y: 301.82,
    width: 43.01,
    height: 3.54,
    rx: 1.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.69,
    y: 341.84,
    width: 43.01,
    height: 3.54,
    rx: 1.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.45,
    y: 98.86,
    width: 233.69,
    height: 133.88,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.07,
    y: 98.86,
    width: 235.53,
    height: 133.88,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.94,
    y: 104.32,
    width: 225.81,
    height: 122.95,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.65 227.27 266.21 104.32 303.65 104.32 275.09 227.27 237.65 227.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.15 227.27 309.7 104.32 326.61 104.32 298.05 227.27 281.15 227.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.23 227.27 376.79 104.32 405.66 104.32 377.11 227.27 348.23 227.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.12,
    y: 104.32,
    width: 0.62,
    height: 122.95,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.82,
    y: 98.86,
    width: 14.04,
    height: 133.88,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.2,
    y: 104.32,
    width: 0.62,
    height: 122.95,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.59,
    y: 98.86,
    width: 0.49,
    height: 133.88,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.68,
    y: 101.02,
    width: 62.12,
    height: 95.23,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.13,
    y: 101.02,
    width: 65.93,
    height: 95.23,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 105.22,
    width: 57.52,
    height: 86.83,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.71,
    y: 119.49,
    width: 36.76,
    height: 50.39,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.78,194V275.9a12.24,12.24,0,0,1-12.25,12.25H284a12.25,12.25,0,0,1-12.25-12.25V194a11.32,11.32,0,0,1,.09-1.43A12.24,12.24,0,0,1,284,181.71H438.53a12.25,12.25,0,0,1,12.17,10.81A11.32,11.32,0,0,1,450.78,194Z",
    style: {
      fill: "#fff",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.59,245.85a33,33,0,0,1-2-17.68c1.84-10.6,10.12-20.16,20.67-22.25,15.34-3,30,9.07,45.66,8.41,11-.46,22.41-7.1,32.26-2.26,15.6,7.68,11.22,31.58,3.7,43.24-7.81,12.12-22.05,19.18-35.9,21.76",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "5,5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.39 296.62 327.99 303.39 337.97 295 337.02 263.43 331.44 261.15 309 283.17 311.39 296.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.73,311l-9.64-3.93a3.81,3.81,0,0,1-2.09-5h0a3.8,3.8,0,0,1,5-2.08L323.6,304a3.81,3.81,0,0,1,2.09,5h0A3.81,3.81,0,0,1,320.73,311Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.25,
    y1: 262.3,
    x2: 326.29,
    y2: 281.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,282.48a1.79,1.79,0,1,1-1-2.33A1.8,1.8,0,0,1,328,282.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.73,311l-9.64-3.93a3.81,3.81,0,0,1-2.09-5h0a3.8,3.8,0,0,1,5-2.08L323.6,304a3.81,3.81,0,0,1,2.09,5h0A3.81,3.81,0,0,1,320.73,311Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.83,283.51a36.47,36.47,0,0,1,68.11,26.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.55,
    y: 309.38,
    width: 2.03,
    height: 2.03,
    transform: "translate(178.86 -127.26) rotate(26.89)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.45,
    y: 283.34,
    width: 2.03,
    height: 2.03,
    transform: "translate(159.69 -99.27) rotate(26.89)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.35,
    y1: 251.75,
    x2: 366.17,
    y2: 275.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46,276.25a1,1,0,0,1-1.94-.31,1,1,0,1,1,1.94.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.39,251.94a1,1,0,1,1-1.93-.31,1,1,0,1,1,1.93.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.7,192.52H271.82A12.24,12.24,0,0,1,284,181.71H438.53A12.25,12.25,0,0,1,450.7,192.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.76,186.58a2,2,0,1,1-2-2A2,2,0,0,1,412.76,186.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.96,
    cy: 186.58,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.16,186.58a2,2,0,1,1-2-2A2,2,0,0,1,433.16,186.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.92,
    y: 196.2,
    width: 18.15,
    height: 30.09,
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.15,
    y: 198.77,
    width: 4.01,
    height: 4.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.31,
    y: 198.77,
    width: 4.01,
    height: 4.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.15,
    y: 205.52,
    width: 4.01,
    height: 4.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.31,
    y: 205.52,
    width: 4.01,
    height: 4.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.15,
    y: 212.27,
    width: 4.01,
    height: 4.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.31,
    y: 212.27,
    width: 4.01,
    height: 4.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.15,
    y: 219.01,
    width: 4.01,
    height: 4.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.31,
    y: 219.01,
    width: 4.01,
    height: 4.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.31,
    y: 198.77,
    width: 4.01,
    height: 4.01,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.15,
    y: 205.52,
    width: 4.01,
    height: 4.01,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.31,
    y: 205.52,
    width: 4.01,
    height: 4.01,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.15,
    y: 212.27,
    width: 4.01,
    height: 4.01,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.31,
    y: 212.27,
    width: 4.01,
    height: 4.01,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.15,
    y: 219.01,
    width: 4.01,
    height: 4.01,
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.31,
    y: 219.01,
    width: 4.01,
    height: 4.01,
    style: {
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Process--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.22,173.28A147.08,147.08,0,0,1,220.94,57.41c68.91,0,126.39,46,142.32,110",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "4,4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.22,159.22a23.54,23.54,0,0,0-23.54,23.55c0,4.67,3.6,11.5,5.27,14.41.73,1.28,1.42,2.57,2.09,3.87l4.66,9.15a3.41,3.41,0,0,0,3,1.87h17a3.41,3.41,0,0,0,3-1.87l4.66-9.15c.66-1.3,1.36-2.59,2.09-3.87,1.67-2.91,5.27-9.74,5.27-14.41A23.55,23.55,0,0,0,77.22,159.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.21,212.07s-.81-21.73-5.56-21-2.22,7.77,9.64,8.15,11.22-8.18,8.72-8.17-6.53,9.57-3.86,21",
    style: {
      fill: "none",
      stroke: "#fafafa",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.39,167.54c3.19-3.35,7.93-5.66,14.84-4.78",
    style: {
      fill: "none",
      stroke: "#fafafa",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2,172.4a11.07,11.07,0,0,1,2.15-2.52",
    style: {
      fill: "none",
      stroke: "#fafafa",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,222.55c0,.11,0,.21,0,.31a7.05,7.05,0,0,1-.2,1.4,6.7,6.7,0,0,1-1.51,2.88,5.6,5.6,0,0,1-4.16,1.9H70.41a6,6,0,0,1-5.67-4.78,7.05,7.05,0,0,1-.2-1.4c0-.1,0-.2,0-.31a5.68,5.68,0,0,1,0-.59,1.1,1.1,0,0,1,0-.18A6.75,6.75,0,0,1,66.25,218a5.6,5.6,0,0,1,4.16-1.9H82.64a6,6,0,0,1,5.57,4.45,5.84,5.84,0,0,1,.26,1.27,1.1,1.1,0,0,1,0,.18A5.68,5.68,0,0,1,88.52,222.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.21,220.51H64.83A6.65,6.65,0,0,1,66.25,218a5.6,5.6,0,0,1,4.16-1.9H82.64A6,6,0,0,1,88.21,220.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.31,224.26a6.7,6.7,0,0,1-1.51,2.88,5.6,5.6,0,0,1-4.16,1.9H70.41a6,6,0,0,1-5.67-4.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.52,222.55c0,.11,0,.21,0,.31h-24c0-.1,0-.2,0-.31a5.68,5.68,0,0,1,0-.59,1.1,1.1,0,0,1,0-.18H88.47a1.1,1.1,0,0,1,0,.18A5.68,5.68,0,0,1,88.52,222.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M76.52,235.86a1.58,1.58,0,1,1-1.58-1.57A1.57,1.57,0,0,1,76.52,235.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "74.94 235.86 74.94 274.31 84.22 274.31 84.22 343.66",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.35,105.49l0-2.31-1.43-.42a14,14,0,0,0-.44-2.31l1.2-.92-.87-2.14-1.49.15a14.5,14.5,0,0,0-1.26-2l.73-1.3-1.62-1.65-1.31.72A14.18,14.18,0,0,0,121.94,92l.18-1.48-2.13-.9-.94,1.16a13,13,0,0,0-2.29-.48l-.4-1.44-2.32,0-.42,1.43a13.72,13.72,0,0,0-2.3.43l-.93-1.19-2.14.86.15,1.48a15.62,15.62,0,0,0-2,1.27l-1.29-.74L103.49,94l.72,1.32a12.28,12.28,0,0,0-1.32,1.94l-1.48-.19-.91,2.13,1.16.93a13.17,13.17,0,0,0-.48,2.31l-1.44.4,0,2.3,1.43.43a14,14,0,0,0,.44,2.31l-1.2.91.87,2.15,1.49-.16a12.58,12.58,0,0,0,1.26,2l-.74,1.31,1.63,1.64,1.31-.71a14.08,14.08,0,0,0,1.93,1.33l-.18,1.48,2.13.9.94-1.15a14.12,14.12,0,0,0,2.31.47l.39,1.44,2.31,0,.42-1.43a12.9,12.9,0,0,0,2.31-.44l.92,1.2,2.14-.86-.15-1.48a14.93,14.93,0,0,0,2-1.27l1.3.74,1.65-1.62-.71-1.32a12.75,12.75,0,0,0,1.32-1.94l1.48.19.91-2.13-1.16-.94a13.89,13.89,0,0,0,.47-2.29ZM115,109.58a5.36,5.36,0,1,1,5.42-5.32,5.36,5.36,0,0,1-5.42,5.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.94,137.9l-3.31-3.43h0a22.23,22.23,0,0,0-.72-4.29l1.76-3.64-4.33-7.07-4-.07a22,22,0,0,0-3.47-2.6h0l-1.56-4.48-8.06-1.93-3.43,3.3h0a21.63,21.63,0,0,0-4.29.73l-3.64-1.78L365.83,117l-.07,4h0a19.91,19.91,0,0,0-2.59,3.48L358.69,126l-1.94,8,3.31,3.43a21.08,21.08,0,0,0,.72,4.32h0L359,145.45l4.33,7.07,4,.08a22,22,0,0,0,3.47,2.6h0l1.55,4.47,8.07,1.94,3.41-3.3a22.51,22.51,0,0,0,4.33-.72h0l3.65,1.76,7.07-4.32.08-4a21.39,21.39,0,0,0,2.59-3.48h0L406,146Zm-27.82,7.16a9.32,9.32,0,1,1,11.24-6.88h0a9.34,9.34,0,0,1-11.24,6.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.76,54l-4.15-2.85h0a22.84,22.84,0,0,0-1.67-4.29L226,42.65l-6-6.41-4.16.78a22.76,22.76,0,0,0-4.15-2h0l-2.56-4.32-8.77-.29-2.85,4.15h0a22.14,22.14,0,0,0-4.29,1.66l-4.15-1.07-6.41,6,.77,4.15h0a21.91,21.91,0,0,0-1.95,4.16l-4.31,2.56-.3,8.76L181,63.68A22.16,22.16,0,0,0,182.7,68h0l-1,4.16,6,6.41,4.16-.76a24.17,24.17,0,0,0,4.15,2h0l2.55,4.3,8.77.31,2.84-4.16a22.59,22.59,0,0,0,4.34-1.66h0l4.15,1.06,6.41-6-.76-4.15a23.08,23.08,0,0,0,1.95-4.15h0l4.31-2.56ZM203.44,67.27a9.86,9.86,0,1,1,10.19-9.51h0a9.87,9.87,0,0,1-10.19,9.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.82,
    cy: 57.41,
    r: 13.8,
    transform: "translate(19.11 160.94) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.32,101l1.32-5.48-3.17-1.81A33.15,33.15,0,0,0,353.7,88l3.35-1.54-.89-5.59-3.62-.43A33.1,33.1,0,0,0,350.6,75l2.47-2.7-3-4.82-3.52,1a34.49,34.49,0,0,0-3.87-4.23L344,60.86l-4.58-3.33-2.86,2.24a35,35,0,0,0-5.2-2.4l-.15-3.63-5.51-1.32-1.78,3.16a34.3,34.3,0,0,0-5.73-.23L316.59,52l-5.58.88-.44,3.62a33.1,33.1,0,0,0-5.37,1.94L302.52,56l-4.83,2.95,1,3.52a32.38,32.38,0,0,0-4.21,3.9L291,65.05l-3.34,4.58L290,72.49a32.07,32.07,0,0,0-2.41,5.22l-3.65.17-1.31,5.47,3.17,1.8a34.47,34.47,0,0,0-.24,5.74l-3.35,1.52.9,5.59,3.61.44a32.65,32.65,0,0,0,1.94,5.36l-2.48,2.7,3,4.82,3.51-1a33.62,33.62,0,0,0,3.88,4.21L295.25,118l4.58,3.33,2.87-2.23a34.63,34.63,0,0,0,5.22,2.39l.15,3.65,5.49,1.32,1.79-3.17a33.34,33.34,0,0,0,5.74.23l1.52,3.35,5.58-.88.45-3.6a37.8,37.8,0,0,0,5.37-1.94l2.68,2.46,4.83-2.94-1-3.53a31.39,31.39,0,0,0,4.19-3.88l3.43,1.25,3.33-4.58-2.24-2.86a33,33,0,0,0,2.39-5.2Zm-39.84,5.52a17.3,17.3,0,1,1,.08,0l-.08,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.32,101l1.32-5.48-3.17-1.81A33.15,33.15,0,0,0,353.7,88l3.35-1.54-.89-5.59-3.62-.43A33.1,33.1,0,0,0,350.6,75l2.47-2.7-3-4.82-3.52,1a34.49,34.49,0,0,0-3.87-4.23L344,60.86l-4.58-3.33-2.86,2.24a35,35,0,0,0-5.2-2.4l-.15-3.63-5.51-1.32-1.78,3.16a34.3,34.3,0,0,0-5.73-.23L316.59,52l-5.58.88-.44,3.62a33.1,33.1,0,0,0-5.37,1.94L302.52,56l-4.83,2.95,1,3.52a32.38,32.38,0,0,0-4.21,3.9L291,65.05l-3.34,4.58L290,72.49a32.07,32.07,0,0,0-2.41,5.22l-3.65.17-1.31,5.47,3.17,1.8a34.47,34.47,0,0,0-.24,5.74l-3.35,1.52.9,5.59,3.61.44a32.65,32.65,0,0,0,1.94,5.36l-2.48,2.7,3,4.82,3.51-1a33.62,33.62,0,0,0,3.88,4.21L295.25,118l4.58,3.33,2.87-2.23a34.63,34.63,0,0,0,5.22,2.39l.15,3.65,5.49,1.32,1.79-3.17a33.34,33.34,0,0,0,5.74.23l1.52,3.35,5.58-.88.45-3.6a37.8,37.8,0,0,0,5.37-1.94l2.68,2.46,4.83-2.94-1-3.53a31.39,31.39,0,0,0,4.19-3.88l3.43,1.25,3.33-4.58-2.24-2.86a33,33,0,0,0,2.39-5.2Zm-39.84,5.52a17.3,17.3,0,1,1,.08,0l-.08,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.61,
    cy: 89.54,
    r: 22.79,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "440.87 148.74 435.13 148.71 431.85 153.43 430.1 147.96 424.61 146.29 429.27 142.94 429.15 137.2 433.78 140.6 439.2 138.72 437.4 144.17 440.87 148.74",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.08 169.18 446.94 166.2 445.55 162.97 448.96 163.82 451.6 161.49 451.84 165 454.87 166.8 451.61 168.11 450.84 171.55 448.58 168.85 445.08 169.18",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.6 329.26 390.52 337.5 396.69 343.06 388.52 344.57 385.14 352.16 381.18 344.86 372.92 343.99 378.63 337.97 376.91 329.84 384.4 333.41 391.6 329.26",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.91 328.33 409.19 326.1 405.81 327.08 407.08 323.8 405.1 320.89 408.62 321.09 410.77 318.31 411.67 321.71 414.98 322.9 412.02 324.81 411.91 328.33",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 445.41,
    rx: 202.28,
    ry: 11.41,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.43,378.91c11.68,7.66,17.75,22.25,17.1,36.19-.32,6.79-2.19,13.74-6.63,18.88s-10.84,7.95-17.25,10c-6.58,2.1-13.56,3.55-20.39,2.52s-13.54-4.88-16.54-11.1c-3.16-6.54-1.81-14.32.36-21.24s5.14-13.82,5-21.07c-.06-5.64-2-11.07-3.4-16.53s-2.33-11.34-.43-16.65,7.45-9.68,13-8.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "5,5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,136.57s-9.09-8.06-18.46,0-10.48,28.89-17.44,38.09c0,0,3.78,7.78,18.73,8.73s31.25-14.23,31.25-14.23S216.6,133.25,200,136.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,177.45c-.86.29-7.61,2.16-18.66,9.2l8,18.48s2.52,14.26,8.59,23.1l12.5,11.65L220.08,229l-6.63-34.55.6-17.68S205.57,170.78,185.1,177.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51,157.66a5.17,5.17,0,0,1-5,4.66,20,20,0,0,1-3.42,3.63c1.08,8.36,6.35,8.36,6.35,8.36-8.29,13.68-18.37,3.14-18.37,3.14a5.94,5.94,0,0,0,4-5,7.45,7.45,0,0,0-.45-3.26c-7.25-.1-11-5.08-10.77-12.44s4.66-14.09,4.66-14.09c4.77,1.87,13.37-.52,13.37-.52-.42,11.3,4.76,13.27,4.76,13.27S206.24,153,205.51,157.66Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.34,160a4.55,4.55,0,0,0,5.15-2.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.82,152.36c0,.66-.38,1.19-.79,1.17s-.73-.57-.71-1.23.38-1.19.8-1.18S188.85,151.69,188.82,152.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,151.63c0,.62-.35,1.1-.73,1.09s-.67-.53-.65-1.14.35-1.1.74-1.08S181,151,181,151.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.87,147.84s1.77-.17,3.24,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,157v-5.38l-2.61,4.56A3.82,3.82,0,0,0,184,157Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.84,194l-.73,17.27-1.14.3c-.64.16-1.26.28-1.87.38-11.3,1.92-17.57-4.63-17.57-4.63l9.91-20.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89,146.63A4.8,4.8,0,0,0,180,147",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.12,254.77s1,28.44,3.74,70.93,17.72,100.13,17.72,100.13h14.5s-8-107.11-8.54-133.89c0,0,34.93,90.23,62.87,119.92l9.32-5.82s-37.84-88.49-41.92-101.29-8.54-60-21.73-75.72H196.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.83 428.62 212.9 440.62 221.89 440.38 220.4 428.62 210.83 428.62",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,414.32c.2.4,5.19,8.78,5.19,8.78l6.18-6.58-5.68-7.78Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.71 424.32 224.12 422.67 223.02 430.36 206.37 431.82 202.71 424.32",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.98 413.62 285.04 402.95 287.04 409.84 275.67 417.71 270.98 413.62",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119 373.28 119.08 339.76 147.34 354.25 119 373.28",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.57 117.81 147.35 354.25 138.38 349.66 127.87 344.27 119.08 339.76 240.29 103.31 250.01 108.29 261.36 114.11 268.57 117.81",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.41 365.62 118.99 373.28 119.03 360.06 130.41 365.62",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.57 117.81 147.35 354.25 138.38 349.66 261.36 114.11 268.57 117.81",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.01 108.29 127.87 344.27 119.08 339.76 240.29 103.31 250.01 108.29",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.34 354.25 118.99 373.28 119.03 359.51 119.07 339.75 147.34 354.25",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,213.31c-18.11,18.49-42,8.86-42,8.86a6.92,6.92,0,0,1-4.07-2.7l-6.55-2.34,2.5-6.32,7.13,1.92,5.2,3.85c18.68,3.28,27.91-8.2,27.91-8.2a61.82,61.82,0,0,0-4.63-14.48l7-13.6.33.51C247.13,197.81,243.76,213.31,243.76,213.31Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,232.42l-5,2C179,238,173,236,173,236c-18.6,4.78-26.75-1.11-26.75-1.11,2.57-8.41,7.86-18.2,12.47-25.88a21.46,21.46,0,0,0,9.65,3.2c-4.51,7.44-8.82,16.68-8.82,16.68,4.68,2.45,15.93-1.36,15.93-1.36L187,226.4Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.54,291.94,206.8,274.6s5.11,27.42,5.14,28S211.54,291.94,211.54,291.94Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,424.37s-4.7-2.53-5.38-.74S281.89,424.37,281.89,424.37Z",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,425s-5,1.24-4.93,2.35S281.89,425,281.89,425Z",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.72,416.69l3.92,3.19a2.15,2.15,0,0,1,.23,3.12L282,437l-.21.2c-.6.5-3.33,2.64-4.65,1.56-1.49-1.22,3-5.74,3.26-8.1.23-1.81.69-5.59.89-7.24a2.12,2.12,0,0,1,.7-1.34l6-5.35A2.15,2.15,0,0,1,290.72,416.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.83,441.56s-2.32-4.86-3.59-4S210.83,441.56,210.83,441.56Z",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.46,441.56s-5.16-2.81-5.76-1.18S210.46,441.56,210.46,441.56Z",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.38,440.38H210.83a22.91,22.91,0,0,1-9.29,5.08c-5.06,1.13-4.59,2-4.59,2s-.84,2.16,2.25,2.62,22.47.57,24.92,0S223.38,440.38,223.38,440.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.13,151.18l-2-.29A1.32,1.32,0,0,0,188.13,151.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.36,150.5l-1.64-.3A1.05,1.05,0,0,0,180.36,150.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82,168.41a5.87,5.87,0,0,1-4.75,4,7.45,7.45,0,0,0-.45-3.26A24.77,24.77,0,0,0,193.82,168.41Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,211.52c-.64.16-1.26.28-1.87.38l1.06-9.41Z",
    style: {
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddService);
export default __webpack_public_path__ + "static/media/addService.521e1b41e793164b733dbc5036342887.svg";
export { ForwardRef as ReactComponent };